import { render } from "./PortalHome.vue?vue&type=template&id=0436d089&scoped=true"
import script from "./PortalHome.vue?vue&type=script&lang=js"
export * from "./PortalHome.vue?vue&type=script&lang=js"

import "./PortalHome.vue?vue&type=style&index=0&id=0436d089&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0436d089"]])

export default __exports__